import React, { useState, useEffect } from 'react';
import { Button, Form, Input, message } from 'antd';
import check from 'asset/img/check.png';
import uncheck from 'asset/img/uncheck.png';
import user from 'asset/img/login_user.png';
import psw from 'asset/img/login_psw.png';
import loginScroll from 'asset/img/login-scroll.png';
import loginDenglu from 'asset/img/login-denglu.png';
import bkLogin from 'asset/img/bk-login.webp';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { userLogin, getUserInfo } from 'network';
import { getDeviceType } from 'utils/device';
import { setUser } from 'actions';
import { ossImageCompress, OssOther } from 'utils/const.js';
import { preloadImages } from 'utils/preload';
import { mirrorAuthToNative, clearNativeAuthMirror } from 'utils/nativePreferences';
import './index.scss';

const Login = () => {
  const [form] = Form.useForm();
  const [rememberPsw, setRememberPsw] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  // 页面类型
  const searchParams = new URLSearchParams(location.search);
  const relogin = searchParams.get('relogin');
  let navigate = useNavigate();

  // 仅“前端首次登录设备”：提前预加载首次登录 Loadding 关键资源，降低切页黑屏概率
  useEffect(() => {
    const key = 'wk_first_login_loading_assets_preloaded_v1';
    if (localStorage.getItem(key) === '1') return;
    // 先写入标记，避免多次进入/热更新反复预加载
    localStorage.setItem(key, '1');
    const bg = ossImageCompress(`${OssOther}/image/loadding.jpg`, 600);
    const pet = `${OssOther}/image/pet-oss/pet-01.png`;
    // 后台预加载，不阻塞 UI
    preloadImages([bg, pet], { timeoutMs: 12000 });
  }, []);

  const onFinish = (values) => {
    const deviceType = getDeviceType();
    userLogin({ mobile: values?.mobile, pwd: values?.pwd, device_type: deviceType || undefined }).then((res) => {
      if (res?.code == 1) {
        return message.info('账号或密码不正确');
      }
      const token = res?.data?.token;
      localStorage.setItem('_pwd', JSON.stringify(token));
      mirrorAuthToNative();
      // 非 VIP（vip_expire 为 1）不允许进入，提示联系老师开通
      return getUserInfo(deviceType ? { device_type: deviceType } : {}).then((infoRes) => {
        if (infoRes?.code !== 0 || !infoRes?.data) return;
        if (infoRes.data.vip_expire === 1) {
          localStorage.removeItem('_pwd');
          clearNativeAuthMirror();
          message.warning('联系老师开通vip权限');
          return;
        }
        dispatch(setUser(infoRes.data));
        if (rememberPsw) {
          const pswobject = { remember: true, pwd: values.pwd, mobile: values.mobile };
          localStorage.setItem('remember', JSON.stringify(pswobject));
          mirrorAuthToNative();
        }
        const isFirstLogin = !!res?.data?.is_first_login;
        const needAssessment = !!res?.data?.need_assessment;
        // 老用户：视为已看过「从 pet 返回/闯关」的右脑 loading，不再弹出
        if (!isFirstLogin) {
          try {
            localStorage.setItem('right_brain_loading_shown_from_pet', '1');
          } catch (e) {}
        }
        if (isFirstLogin) {
          sessionStorage.setItem('first_login_loading', '1');
        }
        // 需测评时跳 welcome（首次登录 或 进过 welcome 但未完成 s111）；后端已区分老用户
        if (needAssessment) {
          return navigate('/welcome');
        }
        return navigate('/home');
      }).catch(() => {
        // getUserInfo 失败时仍放行，无法获取 english_level 则默认不测评
        if (rememberPsw) {
          const pswobject = { remember: true, pwd: values.pwd, mobile: values.mobile };
          localStorage.setItem('remember', JSON.stringify(pswobject));
          mirrorAuthToNative();
        }
        const isFirstLogin = !!res?.data?.is_first_login;
        if (!isFirstLogin) {
          try {
            localStorage.setItem('right_brain_loading_shown_from_pet', '1');
          } catch (e) {}
          return navigate('/home');
        }
        sessionStorage.setItem('first_login_loading', '1');
        return navigate('/home');
      });
    }).catch((error) => {
      console.error(error);
      message.error(error?.response?.data?.msg || error?.message || '登录失败，请重试');
    });
  };

  const gotoForgotPassword = () => {
    navigate('/forgotPassword');
  }

  const gotoRegister = () => {
    navigate('/register');
  }

  const handleRemember = () => {
    if (rememberPsw) {
      const pswobject = { remember: false, pwd: '', mobile: '' }
      localStorage.setItem('remember', JSON.stringify(pswobject));
    }
    setRememberPsw(!rememberPsw)
  }

  useEffect(() => {
    if (relogin === '1') {
      message.info('请重新登录')
    }

    if (relogin === '2') {
      return message.info('试用结束，请购买正式会员')
    }

    let value = localStorage.getItem('remember');

    if (value) {
      try {
        value = JSON.parse(value);
        if (value.remember) {
          setRememberPsw(true);
          form.setFieldsValue({ mobile: value.mobile, pwd: value.pwd });
        }
      } catch (err) {
        console.log(err, 'err')
      }
    } else {
      const pswobject = { remember: false, pwd: '', mobile: '' }
      localStorage.setItem('remember', JSON.stringify(pswobject));
    }
  }, []);

  return (
    <div className='login-container'>
      {/* 背景图片 */}
      <img src={bkLogin} alt="" className="login-bg-img" />
      
      {/* 飘动的云朵 */}
      <div className="login-clouds">
        <div className="cloud cloud-1"></div>
        <div className="cloud cloud-2"></div>
        <div className="cloud cloud-3"></div>
      </div>
      
      {/* 卷轴登录框 */}
      <div className='login-card'>
        <img src={loginScroll} alt="" className='login-scroll-img' aria-hidden />
        <div className='login-card-inner'>
          <img src={loginDenglu} alt="登录" className='login-title-img' />
          <Form
            name="login"
            form={form}
            onFinish={onFinish}
            className='login-form'
          >
          <Form.Item
            name="mobile"
            rules={[
              { required: true, message: '请输入手机号' },
              { type: 'string', pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号' },
            ]}
          >
            <Input 
              prefix={<img src={user} className='input-icon' />} 
              placeholder="请输入手机号" 
              type="number" 
            />
          </Form.Item>
          
          <Form.Item
            name="pwd"
            rules={[{ required: true, message: '请输入密码!' }]}
          >
            <Input.Password 
              prefix={<img src={psw} className='input-icon' />} 
              placeholder="请输入密码" 
            />
          </Form.Item>

          <div className='login-options'>
            <div className='remember' onClick={handleRemember}>
              <div className='checkbox'>
                {rememberPsw ? <img src={check} /> : <img src={uncheck} />}
              </div>
              <span>记住密码</span>
            </div>
            <div className='forget' onClick={gotoForgotPassword}>忘记密码?</div>
          </div>

          <Form.Item className='login-btn-wrap'>
            <Button block type="primary" htmlType="submit" className='login-btn'>
              登 录
            </Button>
          </Form.Item>
        </Form>
          <div className='login-footer'>
            <span className='footer-text'>还没有账号?</span>
            <span className='footer-link' onClick={gotoRegister}>立即注册</span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;
